<template>
  <div v-if="!eventLodging" class="reservation-points-banner mb-4">
    <!-- Collapsed header row -->
    <div class="reservation-points-banner__header" @click="expanded = !expanded">
      <div class="reservation-points-banner__left">
        <div class="reservation-points-banner__icon">
          <img src="../../images/badge-trotter.png" v-set-alt style="width: 28px; height: 36px;" />
        </div>
        <div class="reservation-points-banner__text">
          <p class="raleway-semi-p15 mb-0">Gagnez {{ reservationPoints }} points avec cette réservation</p>
          <p class="raleway-medi-p13 mb-0 text-green reservation-points-banner__subtitle">Débloquez des avantages sur vos prochains séjours</p>
        </div>
      </div>
      <div class="reservation-points-banner__right">
        <span class="reservation-points-banner__badge raleway-semi-p12">Club Hortense</span>
        <i :class="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="reservation-points-banner__chevron"></i>
      </div>
    </div>

    <!-- Expanded benefits body -->
    <div v-if="expanded" class="reservation-points-banner__body">
      <div class="gauge-container">
        <!-- Status indicator arrow -->
        <div class="status-indicator" :class="{ 'no-user': !loyaltyUser }" :style="statusArrowStyle">
          <div v-if="!loyaltyUser" class="status-arrow">
            <span class="text-green raleway-reg-p11">Connectez-vous pour connaitre votre statut</span>
          </div>
          <div v-else class="status-arrow">
            <span class="d-flex flex-column align-items-center">
              <img src="../../images/badge-guest.png" v-set-alt style="width: 43px; height: 38px;" />
              <p class="raleway-semi-p11 mb-0 text-uppercase" style="color: #2C5E4B;">{{ loyaltyUser.loyalty_status }}</p>
              <p class="raleway-medi-p11 mb-0">{{ loyaltyUser.loyalty_points }} points</p>
            </span>
          </div>
        </div>

        <!-- Phone-only status indicator: positioned to the left of the vertical bar -->
        <div v-if="loyaltyUser" class="status-indicator--phone" :style="statusArrowStylePhone">
          <div class="status-arrow-phone">
            <img src="../../images/badge-guest.png" v-set-alt style="width: 32px; height: 28px;" />
            <p class="raleway-semi-p11 mb-0 text-uppercase" style="color: #2C5E4B;">{{ loyaltyUser.loyalty_status }}</p>
            <p class="raleway-medi-p11 mb-0">{{ loyaltyUser.loyalty_points }} pts</p>
          </div>
        </div>

        <!-- Gauge bar grid -->
        <div class="scroll-sync-wrapper">
          <div class="gauge-scroll-wrapper">
            <div class="scroll-inner">
              <div class="gauge-grid" :class="{ 'gauge-grid--with-indicator': loyaltyUser }">
                <div class="gauge-section">
                  <div class="gauge-bar">
                    <div class="gauge-progress" :style="{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }"></div>
                    <div class="gauge-checkpoint">
                      <i :class="loyaltyUser && loyaltyUser.loyalty_points >= 500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                    </div>
                  </div>
                  <div class="gauge-section__content">
                    <div class="guage-label text-uppercase pt-3 raleway-semi-p12 text-green text-center">{{ getDisplayGifts('green trotter') }}</div>
                    <div class="guage-sub-label pt-1 raleway-light-11 text-light-gray-new">GREEN TROTTER</div>
                    <div class="gauge-sub-label pt-1 raleway-light-11 text-light-gray-new">500 POINTS</div>
                  </div>
                </div>

                <div class="gauge-section">
                  <div class="gauge-bar">
                    <div class="gauge-progress"></div>
                    <div class="gauge-checkpoint">
                      <i :class="loyaltyUser && loyaltyUser.loyalty_points >= 1000 ? 'fas fa-check' : 'fas fa-lock'"></i>
                    </div>
                  </div>
                  <div class="gauge-section__content">
                    <div class="guage-label text-uppercase pt-3 raleway-semi-p12 text-green text-center">{{ getDisplayGifts('green trotter plus') }}</div>
                    <div class="guage-sub-label pt-1 raleway-light-11 text-light-gray-new">GREEN TROTTER PLUS</div>
                    <div class="gauge-sub-label pt-1 raleway-light-11 text-light-gray-new">1000 POINTS</div>
                  </div>
                </div>

                <div class="gauge-section">
                  <div class="gauge-bar">
                    <div class="gauge-progress"></div>
                    <div class="gauge-checkpoint">
                      <i :class="loyaltyUser && loyaltyUser.loyalty_points >= 1500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                    </div>
                  </div>
                  <div class="gauge-section__content">
                    <div class="guage-label text-uppercase pt-3 raleway-semi-p12 text-green text-center">{{ getDisplayGifts('green trotter premium') }}</div>
                    <div class="guage-sub-label pt-1 raleway-light-11 text-light-gray-new">GREEN TROTTER PREMIUM</div>
                    <div class="gauge-sub-label pt-1 raleway-light-11 text-light-gray-new">1500 POINTS</div>
                  </div>
                </div>

                <div class="gauge-section">
                  <div class="gauge-bar">
                    <div class="gauge-progress"></div>
                    <div class="gauge-checkpoint">
                      <i :class="loyaltyUser && loyaltyUser.loyalty_points >= 2500 ? 'fas fa-check' : 'fas fa-lock'"></i>
                    </div>
                  </div>
                  <div class="gauge-section__content">
                    <div class="guage-label text-uppercase pt-3 raleway-semi-p12 text-green text-center">{{ getDisplayGifts('green trotter infinite') }}</div>
                    <div class="guage-sub-label pt-1 raleway-light-11 text-light-gray-new">GREEN TROTTER INFINITE</div>
                    <div class="gauge-sub-label pt-1 raleway-light-11 text-light-gray-new">2500 POINTS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="raleway-reg-p13 pt-3 mb-0 text-center" style="color: #555;">
          Plus vous réservez sur Hortense, plus vous cumulez de points, vous donnant accès à de nouveaux privilèges.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reservation-points-banner',
  props: {
    reservationPoints: {
      type: Number,
      default: 0,
    },
    loyaltyUser: {
      type: Object,
      default: null,
    },
    greenTrotters: {
      type: Array,
      default: () => [],
    },
    statusArrowStyle: {
      type: Object,
      default: () => ({}),
    },
    eventLodging: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    // Converts the horizontal left% from statusArrowStyle into a vertical top% for phone layout.
    statusArrowStylePhone() {
      const style = this.statusArrowStyle || {};
      const leftVal = style.left || '0%';
      // Extract numeric percentage from e.g. "calc(37.5% - 22px)" or "12.5%"
      const match = leftVal.match(/([\d.]+)%/);
      const pct = match ? parseFloat(match[1]) : 0;
      return { top: `${pct}%` };
    },
  },
  methods: {
    // Returns the active gift label for a given loyalty status tier.
    getDisplayGifts(statusId) {
      const normalizeName = name =>
        name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      const greenTrotters = this.greenTrotters || [];
      const selectedTrotter = greenTrotters.find(gt => gt.name === statusId);
      if (!selectedTrotter) return '';

      const allGifts = Array.from(
        new Map(
          greenTrotters
            .flatMap(gt => gt.gifts || [])
            .map(gift => [normalizeName(gift.name), gift])
        ).values()
      );

      const currentGifts = selectedTrotter.gifts || [];
      const activeGifts = allGifts
        .filter(gift => currentGifts.some(g => g.name === gift.name))
        .map(g => g.name)
        .slice(-1);

      return activeGifts.join(' - ');
    },
  },
};
</script>

<style lang="scss" scoped>
.reservation-points-banner {
  border: 1px solid #dde8e3;
  border-radius: 10px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    user-select: none;
    gap: 12px;

    &:hover {
      background-color: #edf5f1;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    min-width: 0;
  }

  &__icon {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    min-width: 0;

    p {
      line-height: 1.4;
    }
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  &__badge {
    background-color: #e4f0eb;
    color: #2C5E4B;
    border-radius: 20px;
    padding: 4px 12px;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
  }

  &__chevron {
    color: #2C5E4B;
    font-size: 14px;
    transition: transform 0.2s ease;
  }

  &__body {
    border-top: 1px solid #dde8e3;
    padding: 20px 16px 16px;
    background-color: #f5faf8;

    // Phone-only indicator hidden on desktop
    .status-indicator--phone {
      display: none;
    }

    // Reuse gauge styles from parent (status-bar-container)
    .gauge-container {
      position: relative;
      padding: 0;
    }

    .status-indicator {
      position: relative;
      height: 40px;
      margin-bottom: 5rem;
      z-index: 1;

      &.no-user {
        height: 1px;
        margin-bottom: 4rem;
      }

      .status-arrow {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left: 1%;

        span {
          position: relative;
          margin-bottom: 1px;
          padding: 0.5rem;
          border: 1px solid #2C5E4B;
          border-radius: 15px;
          min-width: 6rem;
        }

        span::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 30%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #2C5E4B;
        }
      }
    }

    .gauge-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0;
      width: 100%;
    }

    .gauge-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .guage-label {
        text-align: center;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }

      .guage-sub-label, .gauge-sub-label {
        text-align: center;
        font-weight: 500;
      }

      .gauge-bar {
        position: relative;
        width: 100%;
        height: 13px;
        background: #e0e0e0;
        border-radius: 10px;

        .gauge-progress {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          background-color: #CFE5DC;
        }

        .gauge-checkpoint {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 28px;
          height: 28px;
          background: white;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 18px;
            color: #3b6152;
          }
        }
      }

      &:last-child .gauge-progress {
        width: 50%;
      }
    }

    .text-green {
      color: #2C5E4B;
    }

    .text-light-gray-new {
      color: #848886;
    }
  }
}

@media screen and (max-width: 480px) {
  .reservation-points-banner {
    &__header {
      padding: 12px;
      gap: 8px;
    }

    &__icon {
      width: 36px;
      height: 36px;
    }

    &__badge {
      display: none;
    }

    &__body {
      padding: 16px 10px 12px;

      // Hide the horizontal status indicator on phone
      .status-indicator {
        display: none;
      }

      // Phone status indicator: sits to the left of the vertical bar, arrow points right
      .status-indicator--phone {
        display: block;
        position: absolute;
        // bar starts at body-padding(10) + gauge-grid-padding-left(58) = 68px from body edge
        // indicator right edge (incl. 7px arrow) should touch bar left: right = total_width - 68px
        // Use right-anchor: distance from right = container_width - 68px
        // Simpler: use left offset so tooltip ends just before the bar
        left: 0;
        right: auto;
        max-width: 58px;
        transform: translateY(-50%);
        z-index: 10;

        .status-arrow-phone {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: white;
          border: 1px solid #2C5E4B;
          border-radius: 8px;
          padding: 4px 4px;
          width: 54px;
          position: relative;

          // Arrow pointing right toward the bar
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: -7px;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 7px solid #2C5E4B;
          }

          img {
            width: 24px !important;
            height: 21px !important;
          }

          p {
            font-size: 8px;
            line-height: 1.2;
            text-align: center;
            margin: 0;
          }
        }
      }

      // Gauge container needs relative positioning for the phone indicator
      .gauge-container {
        position: relative;
      }

      // Unwrap scroll containers so the grid fills width naturally
      .scroll-sync-wrapper,
      .gauge-scroll-wrapper,
      .scroll-inner {
        overflow: visible;
        width: 100%;
      }

      .gauge-grid {
        display: flex;
        flex-direction: column;
        gap: 0;
        width: 100%;

        // Only add left padding when status indicator is shown
        &--with-indicator {
          padding-left: 68px;
        }
      }

      // Each tier: left column = vertical bar, right column = content
      .gauge-section {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        min-height: 90px;

        // Left: vertical bar column (fixed width, full height of row)
        .gauge-bar {
          position: relative;
          width: 13px;
          flex-shrink: 0;
          height: auto;
          background: #e0e0e0;
          border-radius: 0;
          margin-right: 16px;

          .gauge-progress {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: #CFE5DC;
            border-radius: 0;
          }

          // Checkpoint circle centered on the bar
          .gauge-checkpoint {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 28px;
            height: 28px;
            background: white;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;

            i {
              font-size: 14px;
              color: #3b6152;
            }
          }
        }

        // Right: stacked content
        .gauge-section__content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 12px 0;

          .guage-label {
            text-align: left;
            padding-left: 0;
            padding-right: 0;
            padding-top: 0 !important;
          }

          .guage-sub-label,
          .gauge-sub-label {
            text-align: left;
            padding-left: 0;
            padding-right: 0;
            padding-top: 2px !important;
          }
        }
      }

      // Round top of first bar, bottom of last bar
      .gauge-section:first-child .gauge-bar {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .gauge-progress {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }

      .gauge-section:last-child .gauge-bar {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

        .gauge-progress {
          height: 50%;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
  }
}
.text-green {
  color: #2C5E4B;
}
</style>
